// @flow
import type { BuyButtonWidgetOptions } from '../services/buyButtonWidget';

export const injectBuyButtonHook = ({
  widgetOptions,
  buttonRef,
  onClick,
  isServerSideRender
}: {
  widgetOptions: BuyButtonWidgetOptions,
  buttonRef: Object,
  onClick: () => void,
  isServerSideRender: boolean
// eslint-disable-next-line consistent-return
}): Function | void => {
  const handleClickOnButton = (e: Event) => {
    e.stopPropagation();
    onClick();
  };
  
  const buttonElement = buttonRef.current;
  if (buttonElement && !isServerSideRender) {
    window.XBuyButtonWidget.create(widgetOptions);

    buttonElement.addEventListener('click', handleClickOnButton, false);
    return () => buttonElement.removeEventListener('click', handleClickOnButton, false);
  }
};
